package kz.dentalcrm.app.core.base

data class Selectable<T>(
    val selected: Boolean,
    val data: T
)